module.exports = __webpack_public_path__ + "static/img/ic_radius_start@2x.2f6ded9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_radius_start@2x.png
// module id = Hsly
// module chunks = 1